import { yupResolver } from '@hookform/resolvers/yup'
import {
  Button,
  Col,
  Form,
  Grid,
  Input,
  InputMask,
  Row,
  SelectForm
} from 'components'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import { usePersistForm } from 'hooks'
import { useForm } from 'react-hook-form'
import { COLORS, SPACING } from 'utils'
import { TipoPendencia } from 'utils/types'
import * as yup from 'yup'

interface FormProps {
  handleAddNewTypePending: any
  msgError: string
  loading: any
  isModalOpen: boolean
  toggleModal: () => void
  setBackTab: () => void
  setLoading: any
}

const schema = yup
  .object({
    txDescricao: yup
      .string()
      .required('Informe o nome da pendência')
      .max(500, 'Máximo 500 caracteres'),
    txTipo: yup
      .string()
      .required('Informe o Tipo')
      .nullable()
      .min(1, 'Informe o tipo')
  })
  .required()

export const RecordsRegistrationForm: React.FC<FormProps> = ({
  handleAddNewTypePending,
  msgError,
  loading,
  setLoading,
  setBackTab
}) => {
  const { control, handleSubmit, reset, formState, setValue, watch } = useForm<TipoPendencia>({
    resolver: yupResolver(schema)
  })

  usePersistForm("ngt_records_registration", {
    setValue,
    watch
  })

  return (
    <Form
      onSubmit={handleSubmit(handleAddNewTypePending)}
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      padding={SPACING.spacing20}
      boxShadow={`0 0 2em ${COLORS.lightGray}`}
    >
      <Grid
        gridCols="1fr 3fr 1.5fr"
        gridGap={`${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing50} 0`}
      >
        <Col>
          <SelectForm
            defaultValue={null}
            control={control}
            errors={formState.errors}
            formValue="txTipo"
            label="Tipo Documento"
            listOptions={[
              { label: 'Trabalhista', value: 'Trabalhista' },
              { label: 'Previdenciário', value: 'Previdenciário' },
              { label: 'Outros', value: 'Outros' }
            ]}
            placeholder="Selecione"
          />
        </Col>
        <InputMask
          control={control}
          label="Pendência"
          formValue="txDescricao"
          maxLength={250}
          errors={formState.errors}
          required
        />
      </Grid>
      <Row
        justifyContent="flex-end"
        marginTop={SPACING.spacing20}
        marginBottom={SPACING.spacing10}
      >
        <Button
          text="Limpar"
          variantButton="outlined"
          backgroundColor={COLORS.white}
          textColor={COLORS.black}
          marginRight={SPACING.spacing10}
          borderColor={COLORS.transparent}
          onClick={() =>
            reset({
              txDescricao: '',
              txTipo: ''
            })
          }
        />
        <Button
          text="Voltar"
          variantButton="outlined"
          backgroundColor={COLORS.white}
          textColor={COLORS.black}
          borderColor={COLORS.black}
          onClick={() => setBackTab()}
        />
        <Button text="Salvar" type="submit" marginLeft={SPACING.spacing15} />
      </Row>
      <SuccessModal
        open={loading === 'error'}
        message={msgError}
        type="error"
        hideButtonCancel
        handleConfirm={() => setLoading('idle')}
        txtButtonConfirm="Voltar"
      />
    </Form>
  )
}
